import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg width="62" height="65" viewBox="0 0 62 65" xmlns="http://www.w3.org/2000/svg">
      <g strokeLinecap="round" strokeLinejoin="round" stroke="currentColor" fill="none" fillRule="evenodd">
        <path d="M56.62 17.8L61 19.996V64l-20-9.992L21 64 1 54.004v-44l20 9.976 17.094-8.54" />
        <path d="M48.072.646c-5.523 0-10 4.477-10 10 0 9.548 10 22 10 22s10-12.452 10-22c0-5.523-4.477-10-10-10zm0 15.52c-2.982 0-5.4-2.418-5.4-5.4s2.418-5.4 5.4-5.4 5.4 2.418 5.4 5.4-2.418 5.4-5.4 5.4z" strokeWidth="1.077" />
        <path d="M41 54.008V21.416M21 19.98V64" />
      </g>
    </svg>
  </span>
);

export default icon;
